import { useEffect, useState } from 'react'
import { Platform, Pressable, Text, View } from 'react-native'
import { useRouter } from 'expo-router'

import {
  getWebAnalyticsConsent,
  setWebAnalyticsConsent,
} from '../../helpers/webAnalyticsConsent.helper'
import {
  WEB_ANALYTICS_CONSENT_DENIED,
  WEB_ANALYTICS_CONSENT_GRANTED,
} from '../../privacyConsent.constants'
import { webCookieConsentBannerStyles as styles } from './WebCookieConsentBanner.styles'

export function WebCookieConsentBanner() {
  const router = useRouter()
  const [hasDecision, setHasDecision] = useState(true)

  useEffect(() => {
    if (Platform.OS !== 'web') return
    setHasDecision(getWebAnalyticsConsent() !== null)
  }, [])

  if (Platform.OS !== 'web' || hasDecision) return null

  return (
    <View style={styles.container} accessibilityRole="alert">
      <Text style={styles.title}>Cookies and analytics</Text>
      <Text style={styles.message}>
        We use essential cookies for sign-in and app security. We only enable analytics after consent.
        {' '}
        <Text style={styles.link} onPress={() => router.push('/privacy')}>
          Privacy Policy
        </Text>
      </Text>
      <View style={styles.actionsRow}>
        <Pressable
          style={({ pressed }) => [styles.actionButton, pressed && styles.actionButtonPressed]}
          onPress={() => {
            setWebAnalyticsConsent(WEB_ANALYTICS_CONSENT_DENIED)
            setHasDecision(true)
          }}
        >
          <Text style={styles.actionButtonText}>Reject</Text>
        </Pressable>
        <Pressable
          style={({ pressed }) => [
            styles.actionButton,
            styles.actionButtonPrimary,
            pressed && styles.actionButtonPressed,
          ]}
          onPress={() => {
            setWebAnalyticsConsent(WEB_ANALYTICS_CONSENT_GRANTED)
            setHasDecision(true)
          }}
        >
          <Text style={styles.actionButtonText}>Accept</Text>
        </Pressable>
      </View>
    </View>
  )
}

